import classNames from 'classnames'
import React from 'react'

import { Radio } from 'core-components/library/radio'

import styles from './ExceptionWelcomeForm.module.scss'

type TOptions = 'Immediate' | 'Next'

interface IProps {
  isVisible: boolean
  value: TOptions | string
  onChange: (value: TOptions) => void
  isDisabled?: boolean
}

export const CycleEffectOptions = ({ isVisible, value, onChange, isDisabled }: IProps) => {
  return (
    <div
      className={classNames(styles.body__radioMenu, {
        [styles.body__noBorder]: !isVisible,
      })}
    >
      {isVisible && (
        <>
          <div className={styles.radioGroup}>
            <Radio
              className={styles.radioGroup__item}
              label={'Immediate effect'}
              margin={'md'}
              checked={value === 'Immediate'}
              value={'Immediate'}
              onChange={onChange}
              disabled={isDisabled}
            />
            <Radio
              className={styles.radioGroup__item}
              label={'Next cycle effect'}
              margin={'md'}
              checked={value === 'Next'}
              value={'Next'}
              onChange={onChange}
              disabled={isDisabled}
            />
          </div>
          <p>
            <b>Description:</b>
          </p>
          <div className={styles.radioDescription}>
            <div className={styles.radioDescription__title}>Immediate effect:</div>
            <div className={styles.radioDescription__body}>
              If exception is approved, the effect will be immediate for Membership update, or
              benefit of Compensation within the current quarter.
              <br />
              <b> Note</b> compensation exception with immediate effect shall be supported with
              evidence that the partner qualified before the start of the Quarter.
            </div>
          </div>
          <div className={styles.radioDescription}>
            <div className={styles.radioDescription__title}>Next cycle effect:</div>
            <div className={styles.radioDescription__body}>
              If exception is approved the effect will happen with next cycle. Membership updates
              will happen with the next profiling cycle, compensation will be granted for the next
              quarter.
            </div>
          </div>
        </>
      )}
    </div>
  )
}
